import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  public removeLocalStorage(items: string[]) {
    if (items.length) {
      items.forEach(item => {
        localStorage.removeItem(item);
      });
    }
  }

}
